import { all, call, put, select, takeLatest } from "redux-saga/effects";
import * as jsonpatch from "fast-json-patch";
import cloneDeep from "lodash.clonedeep";
import { CREATE_QUOTE, createQuotePending, createQuoteRequested, createQuoteFailure, createQuoteSuccess,
  FETCH_QUOTES, fetchQuotes, fetchQuoteRequested, fetchQuoteFailure, fetchQuoteSuccess,
  FETCH_QUOTE_BY_ID, fetchSingleQuoteByIdRequested, fetchSingleQuoteByIdFailure, fetchSingleQuoteByIdSuccess,
  UPDATE_QUOTE, updateQuoteRequested, updateQuoteFailure, updateQuoteSuccess,
  UPDATE_QUOTE_WITH_STATUS,
  FETCH_QUOTE_BY_USER_ID,
  fetchQuoteByUserIdRequested,
  updateQuotePending,
  fetchQuoteByUserIdSuccess,
  fetchQuoteByUserIdFailure } from "../actions/quote-action-types";
import { updateTask } from "../actions/tasks-action-types";
import httpClient from "./http-client";

import { toggleSnackBar } from "../actions/app-action-types";
import { fetchConsumerChartsData } from "../actions/analytics-action-types";

export function* createQuoteHandler({ payload }) {
  yield put(createQuoteRequested());

  const quote = {
    taskId: payload.taskId,
    itemDetails: payload?.itemDetails,
    userId: payload.userId,
    status: "Requested",
    totalCost: "0",
    dueDate: payload?.targetDate?.getTime(),
    details: {
      whenToComplted: payload.whenToCompleted,
      timeOfDate: payload.timeOfDate,
      movingFrom: {
        address: payload.address,
        appartmentDetails: payload.appartmentDetails,
        propertyDetails: {
          bedroom: payload.bedroom,
          bathroom: payload.bathroom,
          vehicle: payload.vehicle,
          size: payload.size,
        },
        bookingDetails: payload.bookingDetail,
        description: payload.description,
        image: payload.image,
      },
    },
    serviceprovider: [],
  };

  const request = {
    data: quote,
    method: "POST",
    url: "/api/v1/quotes",
  };

  const options = {
    message: "Information saved successfully",
    severity: "success",
  };

  const {
    data, error,
  } = yield call(httpClient, request);

  if (error) {
    yield put(toggleSnackBar(error?.response?.data?.details || "Something went wrong."));
    yield put(createQuoteFailure(error));
  } else {
    yield put(toggleSnackBar(options));
    yield put(createQuoteSuccess(data));
    yield put(createQuotePending());
    yield put(updateTask({
      identifier: payload.taskId, status: "Quoted",
    }));
    yield put(fetchConsumerChartsData());
  }
}

export function* fetchQuotesHandler({ payload }) {
  yield put(fetchQuoteRequested());

  const request = {
    method: "GET",
    params: {
      taskId: payload,
      // status: payload.status,
    },
    url: "/api/v1/quotes",
  };

  const {
    data, error,
  } = yield call(httpClient, request);

  if (error) {
    yield put(fetchQuoteFailure(data));
  } else {
    yield put(fetchQuoteSuccess(data.details));
  }
}

export function* fetchQuoteByIdHandler({ payload }) {
  yield put(fetchSingleQuoteByIdRequested());

  const request = {
    method: "GET",
    url: `/api/v1/quotes/${payload}`,
  };

  const {
    data, error,
  } = yield call(httpClient, request, false);

  if (error) {
    yield put(fetchSingleQuoteByIdFailure(error));
  } else {
    yield put(fetchSingleQuoteByIdSuccess(data.details));
  }
}

export function* updateQuoteHandler({ payload }) {
  yield put(updateQuoteRequested());
  const quotes = yield select((state) => state?.quote?.quotes);
  const updatedQuotes = cloneDeep(quotes);

  const singleQuote = updatedQuotes.find((quote) => quote.identifier === payload.identifier);
  const updates = {
    ...singleQuote,
    ...payload,
  };

  const diffPayload = jsonpatch.compare(singleQuote, updates);

  if (diffPayload.length) {
    const request = {
      data: { payload: diffPayload },
      method: "PATCH",
      url: `/api/v1/quotes/${payload.identifier}`,
    };

    const {
      data, error,
    } = yield call(httpClient, request, true);

    const options = {
      message: "Information saved successfully",
      severity: "success",
    };

    if (error) {
      yield put(toggleSnackBar(error?.response?.data?.details || "Something went wrong."));
      yield put(updateQuoteFailure(error));
    } else {
      yield put(fetchQuotes(payload.taskId));
      yield put(updateQuoteSuccess(data));
      yield put(updateQuotePending());
      yield put(toggleSnackBar(options));
    }
  }
}

export function* updateQuoteWithStatusHandler({ payload }) {
  yield put(updateQuoteRequested());

  const request = {
    method: "PATCH",
    url: `/api/v1/updatequote?jobId=${payload.jobId}&quoteId=${payload.identifier}&status=${payload.status}`,
  };

  const {
    data, error,
  } = yield call(httpClient, request, true);

  const options = {
    message: "Information saved successfully",
    severity: "success",
  };

  if (error) {
    yield put(toggleSnackBar(error?.response?.data?.details || "Something went wrong."));
    yield put(updateQuoteFailure(error));
  } else {
    yield put(fetchQuotes(payload.taskId));
    yield put(updateQuoteSuccess(data));
    yield put(updateQuotePending());
    yield put(toggleSnackBar(options));
  }
}

export function* fetchQuotesByUserHandler() {
  yield put(fetchQuoteByUserIdRequested());

  const userData = yield select((state) => state?.user?.user);
  const userId = userData?.identifier;

  const request = {
    method: "GET",
    params: { userId },
    url: "/api/v1/quotes",
  };

  const {
    data, error,
  } = yield call(httpClient, request);

  if (error) {
    yield put(fetchQuoteByUserIdFailure(error));
  } else {
    yield put(fetchQuoteByUserIdSuccess(data.details));
  }
}

function* Quote() {
  yield all([
    takeLatest(CREATE_QUOTE, createQuoteHandler),
    takeLatest(FETCH_QUOTES, fetchQuotesHandler),
    takeLatest(FETCH_QUOTE_BY_ID, fetchQuoteByIdHandler),
    takeLatest(UPDATE_QUOTE, updateQuoteHandler),
    takeLatest(UPDATE_QUOTE_WITH_STATUS, updateQuoteWithStatusHandler),
    takeLatest(FETCH_QUOTE_BY_USER_ID, fetchQuotesByUserHandler),
  ]);
}

export default Quote;
